export const getIsInViewPort = (current?: HTMLDivElement | null) => {
	if (!current) {
		return false;
	}
	const {top: t, height: h} = current.getBoundingClientRect();
	return t <= window.innerHeight && t + h >= 0;
};
